import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserRoutingModule } from './user-routing.module';
import {UserListComponent} from './user-list/user-list.component';
import {UserAddComponent} from './user-add/user-add.component';
import {UserEditComponent} from './user-edit/user-edit.component';
import {GridModule, ToolbarService} from '@syncfusion/ej2-angular-grids';
import { DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { UserRolesComponent } from './user-roles/user-roles.component';
import { UserAppFeaturesComponent } from './user-app-features/user-app-features.component';
import {FormsModule} from '@angular/forms';
import { UserChangePasswordComponent } from './user-change-password/user-change-password.component';
import {ControlsModule} from '../controls/controls.module';
import { UserBulkImportComponent } from './user-bulk-import/user-bulk-import.component';
import { FileUploadModule } from 'ng2-file-upload';

@NgModule({
  declarations: [
    UserListComponent,
    UserAddComponent,
    UserEditComponent,
    UserRolesComponent,
    UserAppFeaturesComponent,
    UserChangePasswordComponent,
    UserBulkImportComponent
  ],
  imports: [
    CommonModule,
    UserRoutingModule,
    GridModule,
    DateRangePickerModule,
    NgbModule,
    SwitchModule,
    FormsModule,
    ControlsModule,
    FileUploadModule
  ],
  providers: [
    ToolbarService
  ],
  entryComponents: [
    UserChangePasswordComponent
  ]
})
export class UserModule { }
